<div class="flow-connector-group">
  <!-- Connector line above node -->
  <div class="fic-line" *ngIf="showTopConnector"></div>

  <!-- Insert before button -->
  <button
    *ngIf="showInsertBeforeButton && !(hideInsertButtonWhenActive && isActive)"
    class="fic-insert-before"
    (click)="handleInsertBefore($event)"
    [title]="insertBeforeTooltip">
    <svg width="8" height="8" viewBox="0 0 8 8" fill="none">
      <path d="M4 1v6M1 4h6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
  </button>

  <!-- Node card -->
  <div class="flow-node-card"
       [class.active]="isActive"
       [class.catalog-card-variant]="isCatalogVariant"
       [class]="accentClass"
       (click)="handleNodeClick()">

    <!-- Left accent stripe -->
    <div
      *ngIf="showAccentStripe"
      class="node-accent-stripe"
      [class]="'stripe-' + effectiveType.toLowerCase().replace('_', '-')"></div>

    <!-- Drag handle -->
    <div *ngIf="showDragHandle" class="drag-handle" cdkDragHandle>
      <svg width="10" height="14" viewBox="0 0 10 14" fill="none">
        <circle cx="3" cy="3" r="1.2" fill="currentColor"/>
        <circle cx="7" cy="3" r="1.2" fill="currentColor"/>
        <circle cx="3" cy="7" r="1.2" fill="currentColor"/>
        <circle cx="7" cy="7" r="1.2" fill="currentColor"/>
        <circle cx="3" cy="11" r="1.2" fill="currentColor"/>
        <circle cx="7" cy="11" r="1.2" fill="currentColor"/>
      </svg>
    </div>

    <!-- Content -->
    <div class="fn-content">
      <!-- Catalog variant: icon + label in a single header row -->
      <ng-container *ngIf="isCatalogVariant; else defaultTop">
        <div class="fn-catalog-header">
          <div class="fn-catalog-icon" *ngIf="catalogIcon">
            <ng-container [ngSwitch]="catalogIcon">
              <svg *ngSwitchCase="'home'" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                <path d="M9 22V12h6v10"></path>
              </svg>
              <svg *ngSwitchCase="'globe'" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="2" y1="12" x2="22" y2="12"></line>
                <path d="M12 2a15 15 0 0 1 0 20 15 15 0 0 1 0-20z"></path>
              </svg>
              <svg *ngSwitchCase="'table'" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="3" y="3" width="18" height="18" rx="2"></rect>
                <line x1="3" y1="9" x2="21" y2="9"></line>
                <line x1="9" y1="21" x2="9" y2="9"></line>
              </svg>
              <svg *ngSwitchDefault width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="3" y="3" width="7" height="7"></rect>
                <rect x="14" y="3" width="7" height="7"></rect>
                <rect x="3" y="14" width="7" height="7"></rect>
                <rect x="14" y="14" width="7" height="7"></rect>
              </svg>
            </ng-container>
          </div>
          <div *ngIf="showLabel" class="fn-label">{{ displayLabel }}</div>
        </div>
        <div *ngIf="showDescription && displayDescription" class="fn-description">{{ displayDescription }}</div>
      </ng-container>

      <!-- Default (non-catalog) layout -->
      <ng-template #defaultTop>
        <div class="fn-top">
          <span *ngIf="showIndex" class="fn-index">{{ index + 1 }}</span>
          <app-pipeline-node-badge
            *ngIf="showBadge"
            [type]="effectiveType"
            [customLabel]="badgeLabel"
            size="sm"></app-pipeline-node-badge>
          <span *ngIf="showStatusChip" class="fn-status-chip" [class]="statusChip.cls">{{ statusChip.label }}</span>
        </div>
        <div *ngIf="showLabel" class="fn-label">{{ displayLabel }}</div>
        <div *ngIf="showDescription && displayDescription" class="fn-description">{{ displayDescription }}</div>
        <div *ngIf="showMetaChips" class="fn-meta">
          <span class="fn-chip" [class.chip-missing]="isMetaChipMissing(chip)" *ngFor="let chip of effectiveMetaChips">
            {{ chip }}
          </span>
        </div>
      </ng-template>
    </div>

    <!-- Chevron -->
    <div *ngIf="showChevron" class="fn-chevron" [class.open]="isActive">
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path d="M3 5l3 3 3-3" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <button
      *ngIf="showTrailingAction"
      type="button"
      class="fn-trailing-action"
      [class]="trailingActionClass"
      [title]="trailingActionTooltip"
      (click)="handleTrailingAction($event)">
      <svg *ngIf="trailingActionIcon === 'close' || trailingActionIcon === 'remove'" width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path d="M3 3l6 6M9 3 3 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
    </button>
  </div>
</div>
